import classNames from 'classnames';
import BusinessButton from '../../business-button/business-button';

import styles from './b2b-footer-bottom.module.scss';
import { FC } from 'react';
import { BuilderContent } from '@builder.io/react';
import { COLORS } from '../../business-button/business-button.constants';

interface Props {
    ctaLink?: string;
    page: any;
}

export const B2BFooterBottom: FC<Props> = ({ ctaLink, page }) => {
    return (
        <div className={styles.container}>
            <div className={styles.background} />
            <div className={classNames(styles.title)}>Ready to grow your business?</div>
            <BuilderContent model="business-hub" content={page}>
                {(variant) => (
                    <BusinessButton
                        autoMargin={false}
                        link={variant?.signupLink ?? ctaLink}
                        className={styles.button}
                        buttonText="Get started today"
                        target="_blank"
                        color={COLORS.BLACK}
                    />
                )}
            </BuilderContent>
        </div>
    );
};
